// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/" + chunkId + "." + {"140":"50d628dfee7d459ce560","540":"35f0589f3e125717cfd0","676":"061619bcc2170210186d","961":"7c830466f165473e6e79"}[chunkId] + ".js";
};